import { TranslocoGlobalConfig } from '@jsverse/transloco-utils';

const config: TranslocoGlobalConfig = {
  rootTranslationsPath: 'src/assets/i18n/',
  langs: ['en', 'fr'],
  keysManager: {},
  defaultLang: 'en',
};

export const availableLangs = config.langs ?? [];
export type AvailableLangs = (typeof availableLangs)[number];

export default config;
